import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { INewBuilding } from '../../../types/newBuldings';
import { IOffice } from '../../../types/offices';
import { getGeoObject, IGetGeoObjectOptions } from './getGeoObject';

export function getPins(newBuildings: INewBuilding[], offices: IOffice[]): IMapGeoObject[] {
  return [...newBuildings, ...offices].reduce((acc, curr) => {
    const options: IGetGeoObjectOptions = {
      name: String(curr.id),
      id: String(curr.id),
      coordinates: curr.coordinates,
      pinImage: null,
    };

    if (isOffice(curr)) {
      options.pinImage = curr.pinImage || null;
    }

    const pin = getGeoObject(options);

    if (!pin) {
      return acc;
    }

    return [...acc, pin];
  }, []);
}

function isOffice(entity: IOffice | INewBuilding): entity is IOffice {
  return 'pinImage' in entity;
}
